<script setup lang="ts">
defineProps<{ author: string; city: string }>()
</script>

<template>
  <figure class="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
    <!-- Quote icon -->
    <div class="absolute top-4 right-4 text-primary-light/30 group-hover:text-primary-light/50 transition-colors duration-300">
      <svg class="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
      </svg>
    </div>
    
    <!-- Review content -->
    <blockquote class="text-slate-700 leading-relaxed text-base mb-4 pr-8">
      <slot />
    </blockquote>
    
    <!-- Author info with modern styling -->
    <figcaption class="flex items-center space-x-3">
      <div class="h-10 w-10 rounded-full bg-gradient-to-br from-primary-main/10 to-primary-light/20 flex items-center justify-center">
        <span class="text-primary-main font-semibold text-sm">
          {{ author.split(' ').map(n => n[0]).join('') }}
        </span>
      </div>
      <div>
        <div class="font-semibold text-slate-900">{{ author }}</div>
        <div class="text-sm text-slate-500">{{ city }}</div>
      </div>
    </figcaption>
    
    <!-- Hover effect indicator -->
    <div class="absolute bottom-0 left-0 h-1 w-0 bg-primary-main group-hover:w-full transition-all duration-500"></div>
  </figure>
</template>
